import Config from "../../../Config"
export const ImageURLGenerator = (name: string, size: "sm" | "ss") => {
  return `${Config.assetHost}${name}_${size}.jpg`;
};
